import { deleteUsers } from "../../../../../actions/Utilities/ModuleManagement";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteUsers = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteUsers(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["AllUser"]);
      toast.fire("Success", "Users were deactivated successfully", "success");
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Users failed",
        "Server Error: Cannot deactivate Users",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteUsers;
